'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Spinner = require('../components/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _transactions = require('../actions/transactions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Track transaction progress.
 *
 * @param {Object} services
 * @param {String} etherscanUrl
 *
 * @returns {function}
 */
exports.default = function (_ref, etherscanUrl) {
  var notifications = _ref.notifications;
  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;
    return function (next) {
      return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {
          var transactionLink, label, notificationId;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  next(action);

                  // Show a notification when a transaction is created.
                  if (action.type === 'TRANSACTION_CREATED') {
                    transactionLink = etherscanUrl + '/' + action.transactionHash;
                    label = action.label || 'Transaction';
                    notificationId = notifications.info(_react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        label
                      ),
                      _react2.default.createElement('br', null),
                      'Waiting for confirmation.',
                      _react2.default.createElement(_Spinner2.default, { small: true, loading: true, message: 'Waiting for confirmation' }),
                      _react2.default.createElement('br', null),
                      _react2.default.createElement(
                        'a',
                        { target: '_blank', rel: 'noopener noreferrer', href: transactionLink },
                        'Check status'
                      )
                    ), { autoClose: false });

                    dispatch((0, _transactions.transactionProgressNotified)(action.transactionHash, notificationId));
                  }

                  // Dismiss notifications after receipt confirmation.
                  if (action.type === 'TRANSACTION_RECEIPTS_FETCHED') {
                    action.transactionReceipts.forEach(function (receipt) {
                      var transaction = getState().transactions.localTransactions[receipt.transactionHash];
                      if (transaction && transaction.notificationId) {
                        var _label = transaction.label || 'Transaction';
                        // Update notification to indicate success/failure of transaction.
                        notifications.update(transaction.notificationId, {
                          type: receipt.status ? 'success' : 'error',
                          render: _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            _react2.default.createElement(
                              'strong',
                              null,
                              _label
                            ),
                            _react2.default.createElement('br', null),
                            receipt.status ? 'Confirmed' : 'Failed'
                          )
                        });
                      }
                    });
                  }

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }();
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/middleware/trackTransactionProgress.js
// module id = 1154
// module chunks = 0